import { render, staticRenderFns } from "./JbUpdateDetails.vue?vue&type=template&id=16e8132f&"
import script from "./JbUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./JbUpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports